import angular from 'angular';
import '../../layouts.module';
import template from './breadcrumb.component.html';
import './breadcrumb.component.scss';

class BreadcrumbController {
  constructor($transitions, $state) {
    this.$transitions = $transitions;
    this.$state = $state;
    this.crumbs = [];
  }

  $onInit() {
    this.updateCrumbs();
    this.deregister = this.$transitions.onSuccess({}, () => this.updateCrumbs());
  }

  updateCrumbs() {
    this.crumbs = this.$state.$current.path
      .filter((state) => state.data && state.data.breadcrumb)
      .map((state) => ({ label: state.data.breadcrumb, state: state.name }));
  }

  $onDestroy() {
    if (this.deregister) this.deregister();
  }
}

BreadcrumbController.$inject = ['$transitions', '$state'];

angular.module('app.layouts').component('cpBreadcrumb', {
  controller: BreadcrumbController,
  controllerAs: 'vm',
  template
});
